export interface IRoutePageMeta {
    pageName: string
    pagePath: string
}

const routePageNames: Array<{ prefix: string; pageName: string }> = [
    { prefix: '/lk/dashboard', pageName: 'Мониторинг' },
    { prefix: '/lk/applications', pageName: 'Заявки' },
    { prefix: '/lk/signature', pageName: 'Договора на подпись' },
    { prefix: '/lk/commercialOffers', pageName: 'Ком. предложения' },
    { prefix: '/lk/companies', pageName: 'Контрагенты' },
    { prefix: '/lk/listeners', pageName: 'Слушатели' },
    { prefix: '/lk/contracts', pageName: 'Договора' },
    { prefix: '/lk/finalExamination', pageName: 'Итоговые работы' },
    { prefix: '/lk/finality', pageName: 'Доставка' },
    { prefix: '/lk/profile', pageName: 'Мой профиль' },
    { prefix: '/lk/users', pageName: 'Пользователи' },
    { prefix: '/lk/systems', pageName: 'Система' },
    { prefix: '/lk/ocr', pageName: 'OCR — обучение модели' },
    { prefix: '/lk', pageName: 'Мониторинг' },
    { prefix: '/', pageName: 'Авторизация' },
]

const getPageNameByPath = (pathname: string): string => {
    const normalizedPath = pathname.toLowerCase()

    const matchedRoute = routePageNames.find(({ prefix }) => (
        normalizedPath === prefix || normalizedPath.startsWith(`${prefix}/`)
    ))

    return matchedRoute?.pageName || pathname || 'Неизвестная страница'
}

export const getRoutePageMeta = (pathname: string, search: string = '', hash: string = ''): IRoutePageMeta => ({
    pageName: getPageNameByPath(pathname),
    pagePath: `${pathname || '/'}${search}${hash}`,
})

export const getCurrentRoutePageMeta = (): IRoutePageMeta => {
    if (typeof window === 'undefined') {
        return { pageName: '', pagePath: '' }
    }

    return getRoutePageMeta(window.location.pathname, window.location.search, window.location.hash)
}
